export default __webpack_public_path__ + "static/media/an.mohanty.21535695.jpg";